import React, { useRef, useState } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useScrollBehavior } from './useScrollBehavior.js';
import './faq_module.css';

const FAQModule = ({ renderAnimatedLettersByWord, faqItems = [] }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.25 });

  useScrollBehavior();

  const [openIndex, setOpenIndex] = useState(0);

  

  const container = {
    hidden: { opacity: 0, y: 22 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: 'easeOut',
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.55, ease: 'easeOut' }
    }
  };

  return (
    <div id="faqmod_wrap" ref={ref}>
      {/* LEFT */}
      <motion.div
        id="faqmod_left"
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={container}
      >
        <motion.div id="faqmod_kicker" variants={item}>
          Clear Answers • Better Decisions • Less Friction • Stronger Conversion
        </motion.div>

        <motion.h1 id="faqmod_h1" variants={item}>
          {renderAnimatedLettersByWord(
            'Answers to common questions before you start the project.',
            inView
          )}
        </motion.h1>

        <motion.p id="faqmod_p" variants={item}>
          A stronger website project starts with clarity. This section answers common questions
          about process, support, strategy, and what kind of work actually makes sense for a
          business that wants better digital performance.
        </motion.p>

        <motion.div id="faqmod_ctaRow" variants={item}>
          <Link to="/ContactPage" id="faqmod_ctaPrimary">
            Ask a Specific Question
          </Link>

          <div id="faqmod_ctaNote">
            <div className="faqmod_noteTop">Straight answers</div>
            <div className="faqmod_noteBottom">
              Strategy • Design • Development • SEO • AI integration
            </div>
          </div>
        </motion.div>

        <div id="faqmod_visual"></div>
      </motion.div>

      {/* RIGHT */}
      <motion.div
        id="faqmod_right"
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={container}
      >
        {faqItems.map((itemData, index) => {
          const isOpen = openIndex === index;

          return (
            <motion.div
              className={`faqmod_item ${isOpen ? 'open' : ''}`}
              variants={item}
              key={index}
            >
              <button
                type="button"
                className="faqmod_questionRow"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
              >
                <div className="faqmod_questionText">{itemData.question}</div>
                <div className="faqmod_plus">{isOpen ? '−' : '+'}</div>
              </button>

              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    className="faqmod_answerWrap"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.35, ease: 'easeInOut' }}
                  >
                    <div className="faqmod_answer">
                      {itemData.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  );
};

export default FAQModule;